import { Link } from 'gatorcomponents';
import React from 'react';

export default {
  productsDetails: {
    modals: {
      createSite: {
        title: () => (
          <>
            {'Vamos expandir sua marca '}
            <span>criando um novo site</span>
            ?
          </>
        ),
        description: {
          0: domain => (
            <>
              {'5 bilhões de pessoas no mundo estão usando a internet. Não perca tempo e crie um site personalizado para '}
              <span>{`${domain}.`}</span>
            </>
          ),
          1: () => (
            <>
              {'Você pode usar o '}
              <span>Criador de Sites, Wordpress</span>
              {'  ou outras ferramentas para instalar e personalizar. :)'}
            </>
          ),
        },
        buttonLabel: 'Criar site',
        backButtonLabel: 'Não quero expandir minha marca',
      },
    },
  },
  actions: {
    vpsN8N: {
      connectToSshButtonLabel: 'Conectar via SSH',
      openN8NButtonLabel: 'Abrir n8n',
    },
  },
  modalN8n: {
    title: 'Como acessar sua VPS com n8n',
    subtitle: 'Siga os passos abaixo para acessar sua VPS com n8n por meio de SSH.',
    labels: {
      ip: 'IP',
      port: 'Porta',
      user: 'Usuário',
      password: 'Senha',
    },
    step1Title: 'Abra o SSH no computador',
    step1Subtitle: (
      <>
        {'Tem dúvidas sobre o SSH? '}
        <Link
          href="https://suporte.hostgator.com.br/hc/pt-br/articles/30812824748051-Como-acessar-o-SSH"
          target="_blank"
          text="Veja a documentação"
        />
      </>
    ),
    step2Title: 'Copie as credênciais abaixo para se conectar:',
  },
};
